import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Optional } from 'ag-grid-community';

@Component({
  selector: 'app-confirmation-dailogs',
  templateUrl: './confirmation-dailogs.component.html',
  styleUrls: ['./confirmation-dailogs.component.css']
,
  standalone: false
})
export class ConfirmationDailogsComponent implements OnInit {
  header: string = 'Confirmation?'
  content: string = ""
  btnText: string = ""

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDailogsComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: {
      message: string;
      btnText: string;
      onConfirm: () => void;
    }
  ) { }

  ngOnInit(): void {
    console.log("data", this.data)
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onConfirmClick(): void {
    if (this.data.onConfirm) {
      this.data.onConfirm();
    }
    this.dialogRef.close(true);
  }
}

